const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const AssetsUtil = require("../util/AssetsUtil");
const Modal = require("./Modal");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const {Notifications} = require("../util/components/Notifications");
const AT = require("../vault/ActionTypes");
const {
	maybeFlushAfterBlockingModal,
} = require("../../trainer/util/ContinuousPlayStreakModalHallwayDispatch");

const styles = require("./styles/NotificationModal.css");

// Shows user a one-time notification modal

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	Component = withVaultDispatch(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "NotificationModal",

		propTypes: {
			page: PT.object.isRequired,
			user: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			showNotificationModal: function(type) {
				this.setState({
					isModalOpen: true,
					type,
				});
			},
			closeNotificationModal: function() {
				this.setState({isModalOpen: false, type: null});
			},
		},

		getInitialState: function() {
			return {
				isModalOpen: false,
				type: null,
			};
		},

		getModalTypesForDismissAction: function() {
			return ["trophyUnlocked"];
		},

		onClose: function() {
			if (_.includes(this.getModalTypesForDismissAction(), this.state.type)) {
				this.props.dispatch({
					type: AT.USER_DISMISSED_NOTIFICATION_MODAL,
					modalType: this.state.type,
				});
			}
			this.setState({isModalOpen: false});
			this.props.dispatch({
				type: AT.UPDATE_SHOW_NOTIFICATION,
				isShowingNotification: false,
			});
			maybeFlushAfterBlockingModal(this.props.dispatch);
		},

		render: function() {
			let modal = null;
			const {page} = this.props;
			const {type, isModalOpen} = this.state;
			if (isModalOpen && !page.demo) {
				const copyContent = (
					<Notifications
						type={type}
						styles={styles}
						clickHandler={this.onClose}
					/>
				);
				let modalClass = styles.main;
				if (type === "beastbuilder") {
					modalClass += ` ${styles.mainBeastBuilder}`;
				} else if (type === "redesignTrainer") {
					modalClass += ` ${styles.mainRedesign}`;
				} else if (type === "giftRewardForRiverCrossing") {
					modalClass += ` ${styles.mainGiftReward}`;
				} else if (type === "trophyUnlocked") {
					modalClass += ` ${styles.trophyUnlocked}`;
				} else if (type === "leaderboardsTrainer") {
					modalClass += ` ${styles.mainLeaderboards}`;
				}
				modal = (
					<Modal
						portalContainer={PORTAL_CONTAINERS.TRAINER_MESSAGE}
						onClose={this.onClose}
						closeOnBackdropClick={true}
						closeOnEsc={true}
						hasCloseButton={true}
						backdropClass={styles.backdrop}
						modalClass={modalClass}
						levelType="default"
					>
						<img
							className={styles.bg}
							src={AssetsUtil.getConfirmModal("default")}
						/>
						{copyContent}
					</Modal>
				);
			}
			return modal;
		},
	})
);
